import { Typography } from '@euler/app/components/typography';
import { StatusColors } from '@euler/components/Colors';
import { MaybeText } from '@euler/components/MaybeText';
import { ItemProps, TableView } from '@euler/components/TableView';
import { HStack } from '@euler/components/layout/Stack';
import { FontFamily } from '@euler/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { useTheme } from 'styled-components';
import { FieldErrorAnchorView } from '../field-error-focus/FieldErrorAnchorView';
import { FieldErrorAnchorKey } from '../field-error-focus/anchorKeys';
import { useOrderFormStyles } from './styles';

export const Row = memo(
  ({
    style,
    separatorStyle,
    titleStyle,
    titleTextStyle,
    noteStyle,
    title,
    required,
    errorProp,
    ...props
  }: ItemProps & {
    required?: boolean;
    /** the form field this row edits — makes it focusable on a failed submit */
    errorProp?: FieldErrorAnchorKey;
  }) => {
    const { rpx } = useResponsiveContext();
    const styles = useOrderFormStyles();
    const theme = useTheme();
    const item = (
      <TableView.Item
        style={[styles.row, style]}
        separatorStyle={[styles.rowSeparator, separatorStyle]}
        titleStyle={[styles.rowTitle, titleStyle]}
        titleTextStyle={[styles.rowTitleText, titleTextStyle]}
        noteStyle={[styles.note, noteStyle]}
        disabledOpacity={0.5}
        title={
          required ? (
            <HStack>
              <MaybeText
                text={title}
                css={`
                  font-family: ${FontFamily.NotoSans.Medium};
                  font-size: ${rpx(14)}px;
                  line-height: ${rpx(18)}px;
                  color: ${theme.order.labelColor};
                  margin-bottom: ${rpx(5)}px;
                `}
              />
              <Typography.Text
                size={rpx(16)}
                lineHeight={rpx(18)}
                ml={rpx(4)}
                color={StatusColors.Danger}
                css={`
                  transform: translateY(${rpx(2)}px);
                `}
              >
                *
              </Typography.Text>
            </HStack>
          ) : (
            title
          )
        }
        {...props}
      />
    );
    return errorProp ? (
      <FieldErrorAnchorView anchorKey={errorProp}>{item}</FieldErrorAnchorView>
    ) : (
      item
    );
  },
);

Row.displayName = 'TableItem';
